import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VImg,{attrs:{"src":_vm.imageSrc,"height":_vm.height,"max-height":_vm.maxHeight,"width":_vm.width,"max-width":_vm.maxWidth,"contain":""},on:{"load":_vm.onImageLoad,"error":_vm.onImageError},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c(VRow,{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c(VProgressCircular,{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }